import { useState } from "react";
import { useFormState } from "react-hook-form";

import { useTranslation } from "@luna-restaurant/i18n";
import type { ButtonProps } from "@luna-restaurant/ui";
import { Button, useCustomTheme } from "@luna-restaurant/ui";

export function SubmitButton({
  title,
  onPress,
  disabled,
  buttonStyle,
  onHoverIn,
  onHoverOut,
  ...rest
}: { title: string; onPress?: () => void } & Omit<
  ButtonProps,
  "buttonText" | "onPress"
>) {
  const { isSubmitting } = useFormState();
  const { t } = useTranslation();
  const { colors } = useCustomTheme();
  const [isHovered, setIsHovered] = useState(false);
  const isDisabled = isSubmitting || disabled;
  const activeButtonStyle =
    isHovered && !isDisabled
      ? [buttonStyle, { backgroundColor: colors.palette.spinach20 }]
      : buttonStyle;

  return (
    <Button
      buttonText={isSubmitting ? t("common.submitting") : title}
      disabled={isDisabled}
      onPress={onPress}
      buttonStyle={activeButtonStyle}
      onHoverIn={() => {
        setIsHovered(true);
        onHoverIn?.();
      }}
      onHoverOut={() => {
        setIsHovered(false);
        onHoverOut?.();
      }}
      {...rest}
    />
  );
}
